import { Collapse } from 'antd'
import cx from 'classnames'
import { UpOutlined } from '@ant-design/icons'
import styles from './CollapsePanel.css'

const ExpandIcon = ({ isActive }) => (
  <UpOutlined
    rotate={isActive ? 0 : 180}
    style={{ color: '#5478fc' }}
  />
)

const CollapsePanel = props => {
  const {
    className,
    children,
    panelHeader,
    defaultExpanded = true,
    onChange
  } = props

  return (
    <Collapse
      className={cx(
        styles.collapseRow,
        { [className]: className }
      )}
      bordered={false}
      expandIconPosition='end'
      defaultActiveKey={defaultExpanded ? ['1'] : null}
      expandIcon={ExpandIcon}
      onChange={onChange}
    >
      <Collapse.Panel
        key='1'
        header={panelHeader}
      >
        {children}
      </Collapse.Panel>
    </Collapse>
  )
}

export default CollapsePanel
